import React from "react";
import errorImg from "../assets/images/404-Error-Page.svg";
const Page404 = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="space-y-3">
        <h1 className="text-6xl font-bold text-custom-focus-color">404</h1>
        <h1 className="text-6xl font-bold text-custom-focus-color">
          Error Page
        </h1>
        <h3 className="text-custom-focus-color text-3xl">Page not found!</h3>
      </div>

      <div>
        <img src={errorImg} width={700} />
      </div>
    </div>
  );
};

export default Page404;
